import { get, CleanSchema } from '../../../json-transform';
import { getMetaFilters } from '../../utils';
import { transformCaretKeysToDot } from './generalEventUtils';

const getCommonGeneralEventsFiltersQS = new CleanSchema({
  page: get('page').asInt(),
  page_size: get('page_size').asInt(),
  stream_ids: get('stream_ids').asArrayOfOptionValues().ifEmpty(undefined),
  event_create_time__gte: get('event_create_time__gte').asISOString(),
  event_create_time__lt: get('event_create_time__lt').asISOString(),
  event_end_time_gte: get('event_end_time_gte').asISOString(),
  event_end_time_lt: get('event_end_time_lt').asISOString(),
  cities: get('cities').asArrayFromString(),
  areas: get('areas').asArrayFromString(),
  districts: get('districts').asArrayFromString(),
  streets: get('streets').asArrayFromString(),
  house_numbers: get('house_numbers').asArrayFromString(),
  origin_longitude: get('origin_longitude').asFloat().ifNaN(undefined),
  origin_latitude: get('origin_latitude').asFloat().ifNaN(undefined),
  longitude_delta: get('longitude_delta').asFloat().ifNaN(undefined),
  latitude_delta: get('latitude_delta').asFloat().ifNaN(undefined),
  event_type: get('event_type').switch((v) => Array.isArray(v) && v.every((item) => typeof item === 'object'), {
    true: get().asArrayOfOptionValues().ifEmpty(undefined),
    default: get().ifNull(undefined).asArrayFromString().ifEmptyString(undefined),
  }),
});

const getGeneralEventsFiltersQS = new CleanSchema({
  'event.people_count__gte:integer': get('event.people_count__gte:integer').asInt().ifNaN(undefined),
  'event.people_count__lt:integer': get('event.people_count__lt:integer').asInt().ifNaN(undefined),
  stream_ids: get('stream_ids').asArrayOfOptionValues().ifEmpty(undefined),
  'event.event.stream_id__in:string': get('event.event.stream_id__in:string').asArrayOfOptionValues().ifEmpty(undefined),
  'event.fight_score__gte:numeric': get('event.fight_score__gte:numeric').asFloat().toNormalizedPercent().ifNaN(undefined),
  'event.fight_score__lt:numeric': get('event.fight_score__lt:numeric').asFloat().toNormalizedPercent().ifNaN(undefined),
  'event.weapon_score__gte:numeric': get('event.weapon_score__gte:numeric').asFloat().toNormalizedPercent().ifNaN(undefined),
  'event.weapon_score__lt:numeric': get('event.weapon_score__lt:numeric').asFloat().toNormalizedPercent().ifNaN(undefined),
  'event.fire_score__gte:numeric': get('event.fire_score__gte:numeric').asFloat().toNormalizedPercent().ifNaN(undefined),
  'event.fire_score__lt:numeric': get('event.fire_score__lt:numeric').asFloat().toNormalizedPercent().ifNaN(undefined),
  'event.facecover_score__gte:numeric': get('event.facecover_score__gte:numeric').asFloat().toNormalizedPercent().ifNaN(undefined),
  'event.facecover_score__lt:numeric': get('event.facecover_score__lt:numeric').asFloat().toNormalizedPercent().ifNaN(undefined),
  'event.lying_score__gte:numeric': get('event.lying_score__gte:numeric').asFloat().toNormalizedPercent().ifNaN(undefined),
  'event.lying_score__lt:numeric': get('event.lying_score__lt:numeric').asFloat().toNormalizedPercent().ifNaN(undefined),
  'event.handsup_score__gte:numeric': get('event.handsup_score__gte:numeric').asFloat().toNormalizedPercent().ifNaN(undefined),
  'event.handsup_score__lt:numeric': get('event.handsup_score__lt:numeric').asFloat().toNormalizedPercent().ifNaN(undefined),
  'event.fall_score__gte:numeric': get('event.fall_score__gte:numeric').asFloat().toNormalizedPercent().ifNaN(undefined),
  'event.fall_score__lt:numeric': get('event.fall_score__lt:numeric').asFloat().toNormalizedPercent().ifNaN(undefined),
});

export const getGeneralEventsQS = (obj) => {
  const fixedObj = transformCaretKeysToDot(obj);
  return {
    ...getCommonGeneralEventsFiltersQS(obj),
    ...getGeneralEventsFiltersQS(fixedObj),
    ...getMetaFilters(obj),
  };
};
